import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Partner } from '../models/index';
import { OpenModalService } from './shared/modals/open-modal.service';
import { BaseComponent } from './base-component';

@Component({
  selector: 'app-partners-base',
  template: ''
})
export class PartnersBaseComponent extends BaseComponent implements OnInit {
  partners: Partner[];

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    public route: ActivatedRoute,
    public openModalService: OpenModalService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.data.forEach((data: { partners: Partner[] }) => {
      this.validateRouteDataParams(data, ['partners']);
      this.partners = data.partners;
    });

    this.setTitle('Parteneri ' + this.agencyService.agency.name);
  }

  openPartnerModal(partner: Partner): void {
    this.openModalService.showPartnersContent(partner);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/partners-base.component.ts